export const createMyPerformanceRoutes = (base: string) => ({
  index: base,
});
